import React from 'react';
import moment from 'moment-timezone';
import momentTimezone from 'moment-timezone';
import { allTimezones } from 'react-timezone-select';

class Timezone {
    static displayScheduleDateTime(savedDateTime) {
        try {
            const [dateString, timeString] = savedDateTime.split('T');
            const [year, month, day] = dateString.split('-');
            const [hour, minute, second] = timeString.split(':');
            const formattedDate = `${day}-${month}-${year}`;
            let formattedHour = parseInt(hour);
            const ampm = formattedHour >= 12 ? 'PM' : 'AM';
            formattedHour = formattedHour % 12 || 12;
            const formattedTime = `${formattedHour}:${minute} ${ampm}`;
            return { formattedDate, formattedTime }
        }
        catch (e) {
            return { formattedDate: '', formattedTime: '' }
        }
    }

    static getTimezoneName(timeZoneName) {
        const currentDate = moment().tz(timeZoneName);
        const offsetInMinutes = currentDate.utcOffset();
        const hours = Math.abs(Math.floor(offsetInMinutes / 60));
        const minutes = Math.abs(offsetInMinutes % 60);
        const sign = offsetInMinutes < 0 ? '-' : '+';
        const offsetFormatted = `GMT ${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return offsetFormatted;
    }

    static getOffset(dateString) {
        const date = new Date(dateString);
        const options = { timeZone: 'UTC' };
        const offsetName = new Intl.DateTimeFormat('en-US', options).resolvedOptions().timeZone;
    }

    static formatDate(inputDate, outputTimezone, inputTimezone, outputFormat) {
        inputTimezone = inputTimezone || 'Asia/Kolkata';
        outputFormat = outputFormat || 'DD-MM-YYYY hh:mm:ss A';
        const supportedFormats = [
            'DD-MM-YYYY',
            'DD-MM-YYYY hh:mm',
            'DD-MM-YYYY hh:mm A',
            'DD-MM-YYYY hh:mm a',
            'DD-MM-YYYY hh:mm:ss',
            'DD-MM-YYYY hh:mm:ss A',
            'DD-MM-YYYY hh:mm:ss a',
            'DD/MM/YYYY',
            'DD/MM/YYYY hh:mm:ss',
            'DD/MM/YYYY hh:mm:ss A',
            'DD/MM/YYYY hh:mm:ss a',
            'DD/MM/YYYY hh:mm',
            'DD/MM/YYYY hh:mm A',
            'DD/MM/YYYY hh:mm a',
            'YYYY-MM-DD',
            'YYYY-MM-DD hh:mm',
            'YYYY-MM-DD hh:mm A',
            'YYYY-MM-DD hh:mm a',
            'YYYY-MM-DD hh:mm:ss',
            'YYYY-MM-DD hh:mm:ss A',
            'YYYY-MM-DD hh:mm:ss a',
            'YYYY/MM/DD',
            'YYYY/MM/DD hh:mm:ss',
            'YYYY/MM/DD hh:mm:ss A',
            'YYYY/MM/DD hh:mm:ss a',
            'YYYY/MM/DD hh:mm',
            'YYYY/MM/DD hh:mm A',
            'YYYY/MM/DD hh:mm a',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
        ];
        // const convertedDate = moment.tz(inputDate, supportedFormats, inputTimezone).clone().tz(outputTimezone).format(outputFormat);
        const convertedDate = moment.tz(inputDate, supportedFormats, outputTimezone).clone().tz(inputTimezone).format(outputFormat);
        return convertedDate;
    }

    static formatDateForChatList(inputDate, outputTimezone, inputTimezone, outputFormat) {
        inputTimezone = inputTimezone || 'Asia/Kolkata';
        outputFormat = outputFormat || 'DD-MM-YYYY hh:mm:ss A';
        const supportedFormats = [
            'DD-MM-YYYY',
            'DD-MM-YYYY hh:mm',
            'DD-MM-YYYY hh:mm A',
            'DD-MM-YYYY hh:mm a',
            'DD-MM-YYYY hh:mm:ss',
            'DD-MM-YYYY hh:mm:ss A',
            'DD-MM-YYYY hh:mm:ss a',
            'DD/MM/YYYY',
            'DD/MM/YYYY hh:mm:ss',
            'DD/MM/YYYY hh:mm:ss A',
            'DD/MM/YYYY hh:mm:ss a',
            'DD/MM/YYYY hh:mm',
            'DD/MM/YYYY hh:mm A',
            'DD/MM/YYYY hh:mm a',
            'YYYY-MM-DD',
            'YYYY-MM-DD hh:mm',
            'YYYY-MM-DD hh:mm A',
            'YYYY-MM-DD hh:mm a',
            'YYYY-MM-DD hh:mm:ss',
            'YYYY-MM-DD hh:mm:ss A',
            'YYYY-MM-DD hh:mm:ss a',
            'YYYY/MM/DD',
            'YYYY/MM/DD hh:mm:ss',
            'YYYY/MM/DD hh:mm:ss A',
            'YYYY/MM/DD hh:mm:ss a',
            'YYYY/MM/DD hh:mm',
            'YYYY/MM/DD hh:mm A',
            'YYYY/MM/DD hh:mm a',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
        ];
        const convertedDate = moment.tz(inputDate, supportedFormats, inputTimezone).clone().tz(outputTimezone).format(outputFormat);
        return convertedDate;
    }

    static formatDateUsingTimeZone(inputDate, outputTimezone, inputTimezone, outputFormat) {
        inputTimezone = inputTimezone || 'Asia/Kolkata';
        outputFormat = outputFormat || 'DD-MM-YYYY hh:mm:ss A';
        const supportedFormats = [
            'DD-MM-YYYY',
            'DD-MM-YYYY hh:mm',
            'DD-MM-YYYY hh:mm A',
            'DD-MM-YYYY hh:mm a',
            'DD-MM-YYYY hh:mm:ss',
            'DD-MM-YYYY hh:mm:ss A',
            'DD-MM-YYYY hh:mm:ss a',
            'DD/MM/YYYY',
            'DD/MM/YYYY hh:mm:ss',
            'DD/MM/YYYY hh:mm:ss A',
            'DD/MM/YYYY hh:mm:ss a',
            'DD/MM/YYYY hh:mm',
            'DD/MM/YYYY hh:mm A',
            'DD/MM/YYYY hh:mm a',
            'YYYY-MM-DD',
            'YYYY-MM-DD hh:mm',
            'YYYY-MM-DD hh:mm A',
            'YYYY-MM-DD hh:mm a',
            'YYYY-MM-DD hh:mm:ss',
            'YYYY-MM-DD hh:mm:ss A',
            'YYYY-MM-DD hh:mm:ss a',
            'YYYY/MM/DD',
            'YYYY/MM/DD hh:mm:ss',
            'YYYY/MM/DD hh:mm:ss A',
            'YYYY/MM/DD hh:mm:ss a',
            'YYYY/MM/DD hh:mm',
            'YYYY/MM/DD hh:mm A',
            'YYYY/MM/DD hh:mm a',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
        ];
        const convertedDate = moment(inputDate, supportedFormats).tz(inputTimezone).tz(outputTimezone).format(outputFormat);
        return convertedDate;
    }

    static findZoneLabel = (value) => {
        // const zones = momentTimezone.tz.names();
        // const momentTimezone_options = zones.map(zone => ({
        //     label: `(GMT${momentTimezone.tz(zone).format('Z')}) ${zone.replace(/_/g, ' ')}`,
        //     value: zone
        // }));
        if (value == "Asia/Calcutta") {
            value = "Asia/Kolkata";
        }
        const options = Object.keys(allTimezones).map((key) => ({
            label: allTimezones[key],
            value: key,
        }));
        // console.log("options========",options)
        // console.log("momentTimezone_options========",momentTimezone_options)
        const selectedOption = options.find(option => option.value == value);
        return selectedOption?.label;
    };
}

export default Timezone;